module.exports = "/packs/media/images/logo-harbor-8664cbbc1c23dd3ef053fa389d4fdc94.png";